






import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class StatementNone extends Vue {
    @Prop() public year!: string;
    @Prop() public month!: string;
}
